import { render } from "./InstituteSettingsPage.vue?vue&type=template&id=046bcfb0"
import script from "./InstituteSettingsPage.vue?vue&type=script&lang=js"
export * from "./InstituteSettingsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__